import { AgGridTableInnerFilter, Chip, RemoveInnerFilterEvent } from '../../../../core/types/ag-grid-table-filter';
import { Component, input, output } from '@angular/core';
import { TooltipDirective, TooltipPosition } from '../../../../core/directives/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-inner-filters',
  imports: [TranslateModule, MatChipsModule, MatDividerModule, MatIconModule, TooltipDirective],
  templateUrl: './inner-filters.component.html',
  styleUrl: './inner-filters.component.scss',
})
export class InnerFiltersComponent {
  innerFiltersRowCount = input.required<number | string>();
  innerFilters = input<AgGridTableInnerFilter[]>();
  removeInnerFilterEvent = output<RemoveInnerFilterEvent | { removeAll: boolean }>();
  readonly position = TooltipPosition;

  getChips(): Chip[] {
    return (this.innerFilters() ?? []).flatMap((filter) => {
      const values = Array.isArray(filter.filterValue) ? filter.filterValue : [filter.filterValue];
      const translated = Array.isArray(filter.translatedValue) ? filter.translatedValue : [filter.translatedValue];

      return values.map((value, index) => ({
        columnName: filter.columnName,
        value,
        tooltip: filter.tooltip,
        translatedValue: translated.find((v, i) => v.includes(value) || i === index) || '',
      }));
    });
  }

  remove(columnName: string, filterValue: string): void {
    this.removeInnerFilterEvent.emit({ columnName, filterValue });
  }

  removeAll(): void {
    this.removeInnerFilterEvent.emit({ removeAll: true });
  }
}
